export default function Django_Filter_Reference() {
  return <div>Django_Filter_Reference Component</div>;
}
